import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteFailedRequisition } from '../common/api/clients/mariapps.api';
import { queries } from '../common/api/queryKeys/queries';

export const useMariAppsDeleteFailedRequisition = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteFailedRequisition,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.mariAppsFailedRequisitions._def });
        },
    });
};
